import { wait } from '../../utils/wait';
import { DEFAULT_POLLING_INTERVAL, DEFAULT_POLLING_RETRIES_AMOUNT } from './constants';

/**
 * @typedef {Object} PollingRequestResponse
 * @property finalResponse - response of successful polling requests
 */

/**
 * Polling a function with specified interval by specified amount of requests
 * @param {Function} action - function that should be called until successfull requirements are met
 * @param {Function} exitCondition - function that checks if success reqirements are met. This function must return boolean.
 * @param {Number} pollingInterval - interval of polling
 * @param {Number} pollingRetriesAmount - amount of polling retries
 *
 * @returns {PollingRequestResponse}
 */
const poll = async ({
    action,
    exitCondition,
    pollingInterval = DEFAULT_POLLING_INTERVAL,
    pollingRetriesAmount = DEFAULT_POLLING_RETRIES_AMOUNT,
}) => {
    let finalResponse = await action();
    let retriesAttempts = 0;

    while (!exitCondition(finalResponse) && retriesAttempts < pollingRetriesAmount) {
        retriesAttempts++;
        await wait(pollingInterval);
        finalResponse = await action();
    }

    if (exitCondition(finalResponse)) {
        return finalResponse;
    }

    throw new Error(`Polling wasn't successful for function: ${action.name}`);
};

export default poll;
